export const Regions = [
  {
    label: 'Northland',
    value: 'Northland',
  },
  {
    label: 'Auckland',
    value: 'Auckland',
  },
  {
    label: 'Waikato',
    value: 'Waikato',
  },
  {
    label: 'Bay of Plenty',
    value: 'Bay of Plenty',
  },
  {
    label: "Hawke's Bay",
    value: "Hawke's Bay",
  },
  {
    label: 'Gisborne',
    value: 'Gisborne',
  },
  {
    label: 'Taranaki',
    value: 'Taranaki',
  },
  {
    label: 'Manawatū',
    value: 'Manawatū',
  },
  {
    label: 'Whanganui',
    value: 'Whanganui',
  },
  {
    label: 'Wellington',
    value: 'Wellington',
  },
  {
    label: 'Marlborough and Nelson',
    value: 'Marlborough and Nelson',
  },
  {
    label: 'Tasman',
    value: 'Tasman',
  },

  {
    label: 'West Coast',
    value: 'West Coast',
  },
  {
    label: 'Canterbury',
    value: 'Canterbury',
  },
  {
    label: 'Otago',
    value: 'Otago',
  },
  {
    label: 'Southland',
    value: 'Southland',
  },
  {
    label: 'Outside of New Zealand',
    value: 'Outside of New Zealand',
  },
];

export const BankRelationShip = [
  {
    label: 'employed by the bank',
    value: 'employed by the bank',
  },
  {
    label: 'contracted by or seconded to the bank',
    value: 'contracted by or seconded to the bank',
  },
  {
    label: 'involved in the bank’s management (e.g. board director)',
    value: 'involved in the bank’s management (e.g. board director)',
  },
  {
    label: 'volunteering with the bank',
    value: 'volunteering with the bank',
  },
];

export const PrivacyOption = [
  {
    label:
      'I agree the Whistleblowing Service and the bank can receive my personal information.',
    value:
      'I agree the Whistleblowing Service and the bank can receive my personal information.',
  },
  {
    label:
      'I agree only the Whistleblowing Service can receive my personal information. My details may be used by the Service to communicate with me but will not be passed on to the bank.',
    value:
      'I agree only the Whistleblowing Service can receive my personal information. My details may be used by the Service to communicate with me but will not be passed on to the bank.',
  },
  {
    label:
      'I do not agree to the Whistleblowing Service or the bank receiving my personal information. I am making an anonymous report.',
    value:
      'I do not agree to the Whistleblowing Service or the bank receiving my personal information. I am making an anonymous report.',
  },
];

export const ContactPreference = [
  {
    label: 'Email',
    value: 'Email',
  },
  {
    label: 'Phone',
    value: 'Phone',
  },
  {
    label: 'An anonymous contact link',
    value: 'An anonymous contact link',
  },
  {
    label: 'No contact at all',
    value: 'No contact at all',
  },
];

export const ContactPreferenceNotAgree = [
  {
    label: 'An anonymous contact link',
    value: 'An anonymous contact link',
  },
  {
    label: 'No contact at all',
    value: 'No contact at all',
  },
];

export const declareConfirm = [
  {
    label:
      'I believe on reasonable grounds that the information I am providing is true or likely to be true.',
    value:
      'I believe on reasonable grounds that the information I am providing is true or likely to be true.',
  },
];

export const declareUnderstand = [
  {
    label:
      'I have the option to report my concern or issue directly to the bank involved.',
    value:
      'I have the option to report my concern or issue directly to the bank involved.',
  },
  {
    label:
      'I can contact the Service at any time if I believe I am being intimidated, victimised or treated unfairly as a result of reporting this concern or issue.',
    value:
      'I can contact the Service at any time if I believe I am being intimidated, victimised or treated unfairly as a result of reporting this concern or issue.',
  },
];

export const PronounOptions = [
  {
    label: 'He/him',
    value: 'He/him',
  },
  {
    label: 'She/her',
    value: 'She/her',
  },
  {
    label: 'They/them',
    value: 'They/them',
  },
  {
    label: 'Prefer to self-describe',
    value: 'Prefer to self-describe',
  },
];

export const DemographicAges = [
  {
    label: 'Unselected',
    value: '',
  },
  {
    label: 'Under 18',
    value: 'Under 18',
  },
  {
    label: '18-24',
    value: '18-24',
  },
  {
    label: '25-34',
    value: '25-34',
  },
  {
    label: '35-44',
    value: '35-44',
  },
  {
    label: '45-54',
    value: '45-54',
  },
  {
    label: '55-64',
    value: '55-64',
  },
  {
    label: '65-74',
    value: '65-74',
  },
  {
    label: '75-84',
    value: '75-84',
  },
  {
    label: 'Over 85',
    value: 'Over 85',
  },
];

export const DemographicGender = [
  {
    label: 'Unselected',
    value: '',
  },
  {
    label: 'Man',
    value: 'Man',
  },
  {
    label: 'Woman',
    value: 'Woman',
  },
  {
    label: 'Prefer to self-describe',
    value: 'Prefer to self-describe',
  },
];

export const DemographicEthnicities = [
  {
    label: 'NZ European / Pākehā',
    value: 'NZ European / Pākehā',
    inputHelper: 'Add further detail if you wish',
  },
  {
    label: 'Māori',
    value: 'Māori',
    inputHelper: 'e.g. your iwi or hapū',
  },
  {
    label: 'Pacific peoples',
    value: 'Pacific peoples',
    inputHelper: 'e.g. Samoan, Cook Islands, Tongan',
  },
  {
    label: 'European',
    value: 'European',
    inputHelper: 'e.g. British, Irish, French',
  },
  {
    label: 'Asian',
    value: 'Asian',
    inputHelper: 'e.g. Chinese, Indian, Filipino',
  },
  {
    label: 'Another ethnicity',
    value: 'Another ethnicity',
    inputHelper: 'Add further detail if you wish',
  },
];

export const DemographicHearAboutUs = [
  {
    label: 'Unselected',
    value: '',
  },
  {
    label: 'Your bank',
    value: 'Your bank',
  },
  {
    label: 'Google/internet search',
    value: 'Google/internet search',
  },
  {
    label: 'Own knowledge',
    value: 'Own knowledge',
  },
  {
    label: 'Friend, colleague, whānau',
    value: 'Friend, colleague, whānau',
  },
  {
    label: 'Community or advisory service',
    value: 'Community or advisory service',
  },
  {
    label: 'Media',
    value: 'Media',
  },
  {
    label: 'Social media',
    value: 'Social media',
  },
  {
    label: 'Another way',
    value: 'Another way',
  },
];
